import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import OButton from "components/reusable/OButton";
import dayjs from "dayjs";
import CategoryList from "./CategoryList";
import CategoryAdd from "./CategoryAdd";
import CategoryEdit from "./CategoryEdit";
import Pagination from "../../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import helpers from "../../../utils/helpers";
import OSearch from "components/reusable/OSearch";
import CustomSelect from "components/reusable/CustomSelect";
import { statusOptions } from "utils/constants";

const Category = ({ manager }) => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [categoryList, setCategoryList] = useState([]);
  const [categoryAdd, setCategoryAdd] = useState(false);
  const [categoryEdit, setCategoryEdit] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [categoryView, setCategoryView] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filterData, setFilterData] = useState({
    category: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleEdit = (item) => {
    setCurrentItem(item);
    setCategoryEdit(!categoryEdit);
  };

  const handleView = (item) => {
    setCurrentItem(item);
    setCategoryView(!categoryView);
  };

  const handleCategory = () => {
    setCategoryAdd(!categoryAdd);
  };

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const allCategory = async (data) => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData;
      
      let currentPage = page;

      // Safe check to prevent page from going to 0 or negative
      if (
        (data?.deletePage && categoryList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          categoryList?.length >= 1)
      ) {
        if (page > 1) {
          currentPage = page - 1;
          setPage(currentPage);
          setPaginationObj({ ...paginationObj, page: currentPage });
        } else {
          // If we are on page 1 and delete, we still need to trigger a re-fetch
          currentPage = 1; 
        }
      }

      const payload = {
        page: currentPage, // Use the safely calculated page
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format("YYYY-MM-DD"),
          null,
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format("YYYY-MM-DD"),
          null,
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType,
      };
      const path = apiPath.adminCategoryList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setCategoryList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null,
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null,
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null,
        ),
      });
    } catch (error) {
      console.log("error in get all cayegory list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allCategory();
  }, [page, filterData, sort]);

  const handleReset = () => {
    setFilterData({
      category: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTerm("");
  };
  const statusPage = (e) => {
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true,
    });
    setPage(1);
  };

  return (
    <>
      {" "}
      <div className="bg-[#F9F9F9]">
        <div className="border-[#E9EDF9] bg-white border rounded-lg">
          <div className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between">
            <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
              <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
                <div className="relative flex items-center mb-3">
                  <OSearch
                    searchTerm={searchTerm}
                    placeholder="Category name"
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <CustomSelect
                  id="category"
                  options={statusOptions}
                  placeholder="O_ALL"
                  name="category"
                  value={filterData.category}
                  onChange={statusPage}
                  t={t}
                />

                <OButton
                  type="button"
                  extraClasses="ml-3 mb-3"
                  label="Reset"
                  style={{ borderRadius: "0.5rem" }}
                  onClick={() => handleReset()}
                />
              </div>
            </div>
            <div className="lg:pt-0 pt-2">
              <label
                htmlFor="default-search"
                className="text-gray-900 sr-only dark:text-white mb-2 text-sm font-medium "
              >
                {t("O_SEARCH")}
              </label>
              <div className="flex">
                {(manager?.add || user?.role === "admin") && (
                  <button
                    className="bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap"
                    onClick={() => handleCategory()}
                    title="Add category"
                    type="button"
                  >
                    + {t("CATEGORY_ADD_CATEGORY")}
                  </button>
                )}
              </div>
            </div>
          </div>

          <CategoryList
            categoryList={categoryList}
            page={page}
            allCategory={allCategory}
            handleEdit={handleEdit}
            handleView={handleView}
            currentItem={currentItem}
            categoryView={categoryView}
            setSort={setSort}
            sort={sort}
            setPage={setPage}
            manager={manager}
          />
          {categoryEdit && (
            <CategoryEdit
              allCategory={allCategory}
              handleEdit={handleEdit}
              currentItem={currentItem}
            />
          )}

          {categoryAdd && (
            <CategoryAdd
              categoryAdd={categoryAdd}
              allCategory={allCategory}
              handleCategory={handleCategory}
              setPage={setPage}
            />
          )}
          {paginationObj?.totalItems ? (
            <Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Category;
